<template>
  <div class="index-section">
    <Header ref="Headers" />

    <div class="swiper-section">
      <van-swipe @change="onChange" style="height: 220px" :autoplay="3000">
        <van-swipe-item @click="jumpBannerDetail(item)" v-for="(item, index) in imgList" :key="index">
          <div>

            <img class="pic" v-lazy="item.cover" />
            <div class="custom-indicator">
              <span class="title">{{ item.title }}</span>
              <span>{{ index + 1 }}/{{ imgList.length }}</span>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-if="top && top.title" @click="jumpDetail(top)" class="title-new">
      {{ top.title }}
    </div>
    <div class="tab-new">
      <van-tabs v-model="active">
        <van-tab title="时政要闻">
          <list :is-show-time="false" :data="news" />
        </van-tab>
        <van-tab title="全总新闻">
          <list :is-show-time="false" :data="totalNews" />
        </van-tab>
        <van-tab title="省总新闻">
          <list :is-show-time="false" :data="provincialNews" />
        </van-tab>
      </van-tabs>
      <div @click="goToNewsListByTab(active)" class="more">查看更多></div>
    </div>

    <div class="hot-topics">
      <div class="hot-title">
        <span>热门专题</span>
        <div class="more-btn">
          <span class="more" @click="goToTopic()">查看更多></span>
        </div>
      </div>
      <div class="hot-img">
        <img @click="goToTopic(item)" v-for="(item, index) in list" :key="index" :src="item.logo" alt="" />
      </div>
    </div>

    <div class="tab-new tes">
      <van-tabs type="line" :border="true" v-model="active2">
        <van-tab title="部门动态">
          <list :is-show-time="true" :data="deptNews" />
        </van-tab>
        <van-tab title="基层动态">
          <list :is-show-time="true" :data="baseNews" />
        </van-tab>
      </van-tabs>
      <div @click="goToDeptOrBaseNews(active2)" class="more">查看更多></div>
    </div>

    <div class="tab-new tes2">
      <van-tabs type="line" :border="true" v-model="active3">
        <van-tab title="通知公告">
          <list :is-show-time="true" :data="noticeNews" />
        </van-tab>
      </van-tabs>
      <div @click="goToNoticeList()" class="more">查看更多></div>
    </div>


    <div class="tab-new tab-newte">
      <van-tabs v-model="active1">
        <van-tab title="光荣榜">
          <div @click="goToHonorAndModelList()" class="more te">查看更多></div>
          <div class="tc"> </div>
          <list :is-show-time="true" :data="honorList" />
        </van-tab>
        <van-tab title="劳动模范">
          <div @click="goToHonorAndModelList()" class="more te">查看更多></div>
          <div class="tc"> </div>
          <model :data="lmList" />
        </van-tab>
        <van-tab title="陇原工匠">
          <div @click="goToHonorAndModelList()" class="more te">查看更多></div>
          <div class="tc"> </div>
          <model :data="lyList" />
        </van-tab>
        <van-tab title="创新工作室">
          <div @click="goToHonorAndModelList()" class="more te">查看更多></div>
          <div class="tc"> </div>
          <model :data="studioList" />
        </van-tab>
      </van-tabs>
    </div>

    <div class="tab-new tes2 tes-video-staff">
      <van-tabs v-model="active4">
        <van-tab title="视频展播">
          <Video :list="spList" />
        </van-tab>
        <van-tab title="职工文艺">
          <list :is-show-time="true" :data="staffArtsList" />
        </van-tab>
      </van-tabs>
      <div @click="goToVideoOrStaffArts()" class="more">查看更多></div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { Lazyload } from "vant";
import List from "@/components/list.vue";
import Model from "@/components/modelList.vue";
import Footer from "@/components/footer.vue";
import Video from "@/components/video.vue";
import Header from "@/components/header.vue";
Vue.use(Lazyload);
import { get } from "@/request/http";
export default {
  components: {
    Header,
    Footer,
    List,
    Model,
    Video,
  },
  data() {
    return {
      // 顶部轮播与要闻
      news: [],
      imgList: [],
      top: {},
      currentTitle: "",
      current: 0,

      // 新闻 tab 列表
      totalNews: [],
      provincialNews: [],

      // 部门 / 基层动态
      deptNews: [],
      baseNews: [],

      // 通知公告
      noticeNews: [],

      // 热门专题与劳模工匠
      list: [],
      lmList: [],
      lyList: [],
      studioList: [],
      honorList: [],

      // 视频列表
      spList: [],
      // 职工文艺（栏目 508）
      staffArtsList: [],

      // tab 激活态
      active: 2,
      active1: 0,
      active2: 0,
      active3: 0,
      active4: 0,
    };
  },
  computed: {},
  activated() {
    this.$refs.Headers.switchTab(1);
    this.fetchHomeData();
  },
  watch: {
    current(val) {
      if (val && val > 0) {
        this.currentTitle = this.imgList[val].title;
      }
    },
  },

  methods: {
    // -----------------------
    // 路由跳转相关
    // -----------------------
    // 新闻 Tab「查看更多」
    goToNewsListByTab(type) {
      if (type === 0) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50201,
            title: '时政要闻'
          },
        });
      } else if (type === 1) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50202,
            title: '全总新闻'
          },
        });
      } else if (type === 2) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50203,
            title: '省总新闻'
          },
        });
      }
    },

    // 部门 / 基层动态「查看更多」
    goToDeptOrBaseNews(type) {
      if (type === 0) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50102,
            title: '部门动态'
          },
        });
      }
      else if (type === 1) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50103,
            title: '基层动态'
          },
        });
      }
    },

    // 通知公告「查看更多」
    goToNoticeList() {
      this.$router.push({
        path: "/newsList",
        query: {
          categoryId: 505,
          title: '通知公告'
        },
      });
    },

    // 光荣榜 / 劳模 / 工匠 / 工作室「查看更多」
    goToHonorAndModelList() {
      this.$router.push({
        path: "/lmList",
      });
    },

    // 视频展播 / 职工文艺「查看更多」
    goToVideoOrStaffArts() {
      if (this.active4 === 0) {
        this.$router.push({ path: "/videoList" });
      } else {
        this.$router.push({ path: "/staffArtsMore" });
      }
    },

    // 专题跳转
    goToTopic(item) {
      if (item) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: item.id,
            ztIMG: item.logo || "",
            title: item.name || '热门专题',

          },
        });
      } else {
        this.$router.push({
          path: "/specialColumn",
        });
      }
    },
    // 轮播图跳转
    goToBannerDetail(item) {
      this.$router.push({
        path: "/detail",
        query: {
          newsId: item.targetId,
        },
      });
    },
    // 头条新闻跳转
    goToTopNewsDetail(item) {
      if (item.info_type === 3) {
        window.open(item.jump_url)
      } else if (item.info_type === 5) {
        window.open(item.attachment);
      } else {
        this.$router.push({
          path: "/detail",
          query: {
            newsId: item.id,
          },
        });
      }
    },
    // -----------------------
    // 数据请求相关
    // -----------------------
    fetchHomeData() {
      this.fetchBannerList();
      this.fetchTopNews();
      this.fetchNewsListByCategory("50201", "news");
      this.fetchNewsListByCategory("50202", "totalNews");
      this.fetchNewsListByCategory("50102", "deptNews");
      this.fetchNewsListByCategory("50103", "baseNews");
      this.fetchNewsListByCategory("50203", "provincialNews");
      this.fetchNewsListByCategory("505", "noticeNews");
      this.fetchTopicList();
      this.fetchModelWorkerList();
      this.fetchHonorList();
      this.fetchLyCraftsmanList();
      this.fetchStudioList();
      this.fetchVideoNewsList();
      this.fetchStaffArtsNewsList();
    },

    // 光荣榜
    fetchHonorList() {
      get("/gbs/portal/portal/newsPage?limit=5&page=1&categoryId=50701").then((res) => {
        if (res.code !== 0) {
          this.$Toast && this.$Toast.fail(res.msg);
          return;
        }
        this.honorList = res.data.list || res.data
      });
    },
    // 劳动模范
    fetchModelWorkerList() {
      get("/gbs/portal/portal/lamor?limit=2&page=1").then((res) => {
        if (res.code !== 0) {
          this.$Toast.fail(res.msg);
          return;
        }
        this.lmList = res.data.list;
      });
    },
    // 获取陇原工匠
    fetchLyCraftsmanList() {
      get('/gbs/portal/portal/studio?limit=2&page=1&type=1').then(res => {
        if (res.code !== 0) {
          this.$Toast && this.$Toast.fail(res.msg);
          return;
        }
        this.lyList = res.data.list
      })
    },
    // 获取劳模创新工作室
    fetchStudioList() {
      get('/gbs/portal/portal/studio?limit=2&page=1&type=0').then(res => {
        if (res.code !== 0) {
          this.$Toast && this.$Toast.fail(res.msg);
          return;
        }
        this.studioList = res.data.list;
      })
    },

    fetchVideoNewsList() {
      get(
        "/gbs/portal/portal/newsPage?limit=10&page=1&categoryId=504&title="
      ).then((res) => {
        if (res.code !== 0) {
          this.$Toast.fail(res.msg);
          return;
        }

        if (Array.isArray(res.data.list) && res.data.list.length > 0) {
          this.spList = res.data.list.slice(0, 4);
        } else {
          this.spList = [];
        }
      });
    },

    fetchStaffArtsNewsList() {
      get(
        "/gbs/portal/portal/newsPage?limit=5&page=1&categoryId=508&title="
      ).then((res) => {
        if (res.code !== 0) {
          this.$Toast && this.$Toast.fail(res.msg);
          return;
        }
        const rows = res.data.list || res.data;
        this.staffArtsList = Array.isArray(rows) ? rows : [];
      });
    },

    fetchTopicList() {
      get("/gbs/portal/portal/topic").then((res) => {
        if (res.code !== 0) {
          this.$Toast.fail(res.msg);
          return;
        }
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.list = res.data
        }
      });
    },

    fetchNewsListByCategory(categoryId, target) {
      get(
        `/gbs/portal/portal/newsPage?limit=7&page=1&categoryId=${categoryId}&title=`
      ).then((res) => {
        if (res.code !== 0) {
          this.$Toast.fail(res.msg);
          return;
        }
        this[target] = res.data.list || res.data;
      });
    },
    fetchTopNews() {
      get("/gbs/portal/articles/getTop").then((res) => {
        if (res.code !== 0) {
          this.$Toast.fail(res.msg);
          return;
        }
        this.top = res.data;
      });
    },
    fetchBannerList() {
      get("/gbs/portal/portal/banners").then((res) => {
        if (res.code !== 0) {
          this.$Toast.fail(res.msg);
          return;
        }
        this.imgList = res.data;
        this.currentTitle = this.imgList[0].title;
      });
    },
    onChange(index) {
      this.current = index;
    },
    gotoChild() {
      this.$router.push({
        path: "/child",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/variable.scss";
.index-section {
  background: $bg-gray;
  position: relative;
  min-height: 100vh;
}



.custom-indicator {
  position: absolute;
  height: 78px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 0px 0px;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 5px;

  .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }

  span {
    font-size: 24px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    text-align: left;
  }
}

.swiper-section {
  position: relative;
  width: 100%;
  height: 55vw;

  .pic {
    width: 100%;
    height: 100%;
  }
}

.title-new {
  margin: 0 auto;
  margin-bottom: 16px;
  position: relative;
  width: 100%;
  height: 70px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: $font-size-title-lg;
  color: $color-primary-text;
  line-height: 70px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #ffffff;
  padding: 0 16px;
  box-sizing: border-box;

  &:active {
    background-color: #f5f5f5;
  }
}

.tab-new {
  margin: 0 auto;
  margin-bottom: 16px;
  position: relative;
  width: 100%;
  padding: 20px 16px 0;
  box-sizing: border-box;
  background: #ffffff;

  /deep/ .van-tabs__wrap {
    position: relative;
    width: 75%;
  }

  /deep/ .van-tabs__nav {
    margin: 0;
  }

  .more {
    width: auto;
    position: absolute;
    top: 28px;
    right: 16px;
    font-size: $font-size-caption;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    color: $color-text-sub;
    line-height: 30px;
    text-align: right !important;
    padding: 4px 8px;

    &:active {
      opacity: 0.6;
    }
  }

  .te {
    top: 100px;
    right: 4px;

  }

  .tc {
    width: 100%;
    height: 70px;
  }

}

.tab-newte {

  /deep/ .van-tabs__wrap {
    position: relative;
    width: 100%
  }
}

.tes {

  /deep/ .van-tabs__wrap {
    position: relative;
    width: 70%;
  }

  /deep/ .van-tabs__nav {
    margin: 0;
  }
}

.tes2 {

  /deep/ .van-tabs__wrap {
    position: relative;
    width: 45%;
  }

  /deep/ .van-tabs__nav {
    margin: 0;
  }
}




.hot-topics {
  margin: 0 auto;
  margin-bottom: 16px;
  position: relative;
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 20px 0;

  .hot-title {
    margin: 0 auto;
    width: 95%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .more-btn {
      display: flex;
      align-items: center;

      .more {
        font-weight: 400;
        font-size: 28px;
        color: #9a9a9a;
        line-height: 28px;
      }

      img {
        margin-left: 10px;
        width: 15px;
        height: 24px;
      }
    }

    span {
      font-weight: 600;
      font-size: 36px;
      color: #000000;
      line-height: 42px;
    }
  }

  .hot-img {
    width: 100%;
    min-height: 140px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    padding: 0 10px 10px;

    &::-webkit-scrollbar {
      display: none;
    }

    img {
      margin: 10px;
      width: 280px;
      height: 120px;
      border-radius: 8px;
      flex-shrink: 0;
      scroll-snap-align: start;
      object-fit: cover;
    }
  }
}


.tes2 {

  /deep/ .van-tabs__wrap {
    position: relative;
    width: 40%;
  }

  /deep/ .van-tabs__nav {
    margin: 0;
  }
}

/* 视频展播 + 职工文艺 双 Tab，与「部门/基层」约 70% 宽度一致 */
.tab-new.tes2.tes-video-staff {
  /deep/ .van-tabs__wrap {
    width: 70%;
  }
}


/deep/ .van-tab--active .van-tab__text {
  color: #ee0a24;
  /* 你可以修改为任何你需要的颜色 */
  font-weight: 600;
}

/deep/ .van-tab__text {
  font-weight: 600;
}

/deep/ .van-tabs__line {
  width: 90px;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  height: 36px;
}

/deep/.van-tab {
  font-size: 16px;
}

/deep/.van-hairline--top-bottom::after {
  border-width: 0;
}
</style>